<template>
  <Meta
    name="twitter:title"
    :content="gameData?.meta_title"
    v-if="gameData?.meta_title"
  />
  <Meta
    name="twitter:description"
    :content="gameData?.description"
    v-if="gameData?.description"
  />
  <Meta
    name="og:description"
    :content="gameData?.description"
    v-if="gameData?.description"
  />
  <Meta
    name="og:title"
    :content="gameData?.meta_title"
    v-if="gameData?.meta_title"
  />
  <Meta
    name="og:image"
    :content="`https://boostingmarket.com/images/og-images/${currentGameSlug}-og.png?v=13`"
  />
  <Meta
    name="twitter:image"
    :content="`https://boostingmarket.com/images/og-images/${currentGameSlug}-og.png?v=13`"
  />

  <img
    class="main_layout_bg sm-hide"
    :src="`https://cdn-assets.boostingmarket.com/games/${currentGameSlug}/banner_bg.webp`"
    loading="eager"
    alt="Boostingmarket.com website background image"
    v-if="
      currentGameSlug !== 'ow-boost' && currentGameSlug !== 'call-of-duty-boost'
    "
  />

  <LazyPageOverview
    v-if="
      ![
        'world-of-warcraft-boost',
        'call-of-duty-boost',
        'gta-6-boost',
        'path-of-exile-2-boost',
        'fc-boost',
      ].includes(currentGameSlug)
    "
  />
  <LazyPageNestOverview
    v-else-if="['path-of-exile-2-boost', 'fc-boost'].includes(currentGameSlug)"
  />

  <LazyPageGtaOverview v-else-if="currentGameSlug === 'gta-6-boost'" />
  <LazyPageMmoOverview
    v-else-if="currentGameSlug === 'world-of-warcraft-boost'"
  />
  <LazyPageCodOverview v-else-if="currentGameSlug === 'call-of-duty-boost'" />
</template>

<script setup>
import { ref, watch } from "vue";
definePageMeta({
  layout: "default",
  pageInfo: {
    name: "overview-game-page",
  },
});

// HOOKS
const { currentGameSlug } = useGameComposable();
const { t, locale } = useI18n();
const gameStore = useGameStore();
const { getUtm } = useUserStore();
const router = useRouter();
const localePath = useLocalePath();

const nuxtApp = useNuxtApp();

const route = router.currentRoute;
const localeChange = ref(false);

useHead({
  meta: [
    { name: "title", content: t(`${currentGameSlug}.meta_title`) },
    { name: "description", content: t(`${currentGameSlug}.description`) },
  ],
});

const gameData = ref(null);

const mmoGames = ["world-of-warcraft-boost"];
const gameSlug = currentGameSlug;
let path = "get-game";
if (mmoGames.includes(gameSlug)) {
  path = "get-mmo-game";
}
gameStore.resetGame();

const { data: response, error } = await useApiFetch(
  `/api/${path}/${gameSlug}`,
  {
    method: "post",
    fetchKey: `get-game-${gameSlug}-${locale.value}`,
    body: {
      params: [
        "servers",
        "platforms",
        "roles",
        "faqs",
        "boosters",
        "game_season",
      ],
      locale: locale.value,
      // gameSlug: gameSlug,
    },
    initialCache: false,
    transform(input) {
      return {
        data: input.data,
        fetchedAt: new Date(),
      };
    },
    getCachedData(key) {
      const data = nuxtApp.payload.data[key] || nuxtApp.static.data[key];
      if (!data) {
        return;
      }

      const expirationDate = new Date(data.fetchedAt);
      expirationDate.setTime(expirationDate.getTime() + 22160000);
      const isExpired = expirationDate.getTime() < Date.now();
      if (isExpired) {
        return;
      }
      return data;
    },
  }
);

if (error.value?.data && currentGameSlug !== "world-of-warcraft-boost") {
  throw createError({
    statusCode: "404",
    statusMessage: "Not Found",
  });
}

const handleSchema = () => {
  let schema = document.createElement("script");
  schema.type = "application/ld+json";
  const reviewCount = gameData.value?.reviews || 500;
  let script = document.createTextNode(
    '{"@context": "https://schema.org/", "@type": "Product", "name": "' +
      gameData.value.title +
      '", "image": "' +
      gameData.value.image +
      '", "description": "' +
      gameData.value.description +
      '", "brand": { "@type": "Brand", "name": "Boostingmarket.com" }, "offers": { "@type": "AggregateOffer", "url": "https://boostingmarket.com' +
      route.value.path +
      `", "priceCurrency": "USD", "lowPrice": "0.99", "highPrice": "299.99", "offerCount": "1" }, "aggregateRating": {"@type": "AggregateRating", "ratingValue": "4.9", "bestRating": "5", "worstRating": "1", "ratingCount": "${reviewCount}"}}`
  );
  schema.appendChild(script);
  document.head.appendChild(schema);
};
addCanonicalLink(route.value.fullPath);

if (response.value?.data) {
  gameData.value = response.value?.data;
  gameStore.setGame(response.value?.data);
  useSeoMeta({
    title: response.value?.data?.meta_title,
    description: response.value?.data?.description,
  });
}
onNuxtReady(() => {
  if (response.value?.data) {
    const utmDataSet = getUtm;

    window?.analytics?.page("Game Page", {
      title: response.value?.data?.title,
      ...utmDataSet,
    });

    handleSchema();
  }
});
</script>
